import * as React from "react";
import { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

interface PolicyProps {
  policies: any;
}

interface ChartData {
  labels: string[];
  datasets: {
    data: number[];
    borderColor: string;
    backgroundColor: string;
    fill: boolean;
  }[];
}

const PolicyPerMonthChart: React.FC<PolicyProps> = ({ policies }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const [data, setData] = useState<ChartData>({
    labels: [],
    datasets: [
      {
        data: [],
        borderColor: "#f04f05",
        backgroundColor: "rgba(240, 79, 5, 0.1)",
        fill: true,
      },
    ],
  });

  useEffect(() => {
    // Function to calculate totals for each month
    const calculateTotalsByMonth = () => {
      const today: Date = new Date();
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const months: string[] = [];
      const totals: number[] = Array(12).fill(0);

      for (let i = 12; i > 0; i -= 1) {
        const targetMonth = (today.getMonth() - i + 12) % 12;
        months.push(monthNames[targetMonth]);
      }

      policies.forEach((policy: any) => {
        if (policy?.DateRegistered) {
          const policyDate = new Date(policy.DateRegistered);

          const monthIndex =
            (today.getMonth() - policyDate.getMonth() + 12) % 12;
          totals[monthIndex] += 1;
        }
      });

      return {
        labels: months,
        datasets: [
          {
            label: "Number of Policies",
            data: totals,
            borderColor: "#f04f05",
            backgroundColor: "rgba(240, 79, 5, 0.1)",
            fill: true,
          },
        ],
      };
    };

    setData(calculateTotalsByMonth());
  }, [policies]);

  const options = {
    responsive: true,
    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        position: "top" as const,
        display: true,
      },
      title: {
        display: false,
      },
    },
    tension: 0.5,
  };

  return (
    <>
      <Line height={"100%"} options={options} data={data} />
    </>
  );
};

export default PolicyPerMonthChart;
